function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import shallow from 'zustand/shallow';
import useStore from './../store.js';
import { UNTD_LAYERS } from './../../../../constants/layers';
import FilterSeries from './FilterSeries';
import { ButtonGroup, Button } from 'reactstrap';
import Panel from '../../../core/Panel/Panel.js';
import PanelHeader from '../../../core/Panel/PanelHeader.js';
import PanelBody from '../../../core/Panel/PanelBody.js';

var PanelFilterView = function PanelFilterView(_ref) {
  var onClose = _ref.onClose,
      props = _objectWithoutPropertiesLoose(_ref, ["onClose"]); // Generic state setter.


  var _useStore = useStore(function (state) {
    return [state.setStoreValues, state.activeLayers];
  }, shallow),
      setStoreValues = _useStore[0],
      activeLayers = _useStore[1];

  var handleSelect = function handleSelect(e) {
    // console.log('layer selected, ', e.currentTarget.id)
    var layerIndex = UNTD_LAYERS.findIndex(function (layer) {
      return layer.id === e.currentTarget.value;
    });
    var currentIndex = activeLayers.findIndex(function (l) {
      return l === 1;
    });
    if (layerIndex === currentIndex) return;
    setStoreValues({
      activeFeature: 0,
      // clear active location when changing regions
      activeLayers: activeLayers.map(function (layer, index) {
        return index === layerIndex ? 1 : 0;
      })
    });
  };

  return /*#__PURE__*/React.createElement(Panel, _extends({
    className: "map-panel-slideout-filters tour-desk-5"
  }, props), /*#__PURE__*/React.createElement(PanelHeader, {
    onClose: onClose,
    className: "flex-column align-items-start"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "gotham18"
  }, i18n.translate('UI_MAP_PANEL_HEADING')), /*#__PURE__*/React.createElement("label", {
    htmlFor: "geographyGroup",
    className: "map-panel-instructions mt-3"
  }, i18n.translate('UI_MAP_FILTER_INSTRUCTIONS_UNTD')), /*#__PURE__*/React.createElement(ButtonGroup, {
    id: "geographyGroup",
    className: "tour-desk-6"
  }, UNTD_LAYERS.map(function (el, i) {
    return /*#__PURE__*/React.createElement(Button, {
      key: el.id,
      color: "outlined",
      className: "text-capitalize",
      value: el.id,
      active: activeLayers[i] === 1,
      onClick: handleSelect
    }, i18n.translate(el.label));
  }))), /*#__PURE__*/React.createElement(PanelBody, null, /*#__PURE__*/React.createElement(FilterSeries, null)));
};

export default PanelFilterView;